import config from '../config/app-config';
import request from '../utils/request';
import tools from '../utils/tools';

const api = config.apiDomain;
const live = config.liveDomain;
// 任我销项目
// 获取验证码
export const sendSms = (data) => request.get({ url: api.concat(`/api/order/sendSms${data}`) });

// 产品详情
export const getProductDetails = (data) => request.get({ url: api.concat(`/api/product/shareProductDetails${data}`) });

// 添加订单 拿取orderId
export const addOrderByH5 = (data) => request.postJson({ url: api.concat('/api/order/addOrderByH5'), data });

// 调取微信支付，跳转链接
export const wxH5Pay = (data) => request.postJson({ url: api.concat('/api/order/wxH5Pay'), data });

// 订单详情
export const getOrderDetailsByH5 = (data) => request.get({ url: api.concat(`/api/order/getOrderDetailsByH5${data}`) });

// 调取微信支付，跳转链接
export const wxJsApiPay = (data) => request.postJson({ url: api.concat('/api/order/wxJsApiPay'), data });

// 获取openid
export const getOpenId = (data) => request.get({ url: api.concat(`/api/order/getOpenId${data}`) });

export const getQRCodeSetting = (productId) => {
  const url = api.concat('/api/order/getCompanyQrcode');
  const data = { productId };
  return request.postJson({ url, data });
};

export const getWXAppId = (productId) => {
  const url = api.concat('/api/pay/getConfiguration');
  const data = { productId };
  return request.postJson({ url, data });
};

/**
 * 获得购买协议
 * @param productId
 * @returns {*}
 */
export const getProtocolDetail = (productId) => {
  const url = api.concat('/api/setting/getProtocol');
  const data = { productId };
  return request.postJson({ url, data });
};

export const getBroadcast = (broadcastId) => {
  // 大屏幕订单列表查询
  const url = api.concat(`/api/broadcast/getOrderList?broadcastId=${broadcastId}`);
  return request.get({ url });
};

/**
 * 获得自定义表单信息
 */
export const getFormInfo = (productId, formId) => {
  const url = api.concat('/api/product/get_form_info');
  const data = { productId, formId };
  return request.postJson({ url, data });
};

/**
 * 保存自定义表单信息
 */
export const saveFormInfo = ({
  productId, formId, customerInfo, shareUserId,
}) => {
  const url = api.concat('/api/product/add_form_info');
  const data = {
    productId, formId, customerInfo, shareUserId,
  };
  return request.postJson({ url, data }).then(tools.catchResultHandle);
};

/**
 * 订单页面信息查询
 */
export const getOrderInfo = (productId, specificationId) => {
  const url = api.concat('/api/product/get_invoice_address');
  const data = { productId, specificationId };
  return request.postJson({ url, data });
};

/**
 * 登录 手机号验证码
 */
export const orderLogin = (phone, code) => {
  const url = api.concat('/h5/login/phoneLogin');
  const data = { phone, code };
  return request.postJson({ url, data }).then(tools.catchResultHandle);
};

/**
 * 获取交易订单详情
 * @param pageNum
 * @param pageSize
 * @returns {*}
 */
export const getOrderList = (pageNum, pageSize) => {
  const url = api.concat('/h5/expressOrder/getPage');
  const data = { pageNum, pageSize };
  return request.get({ url, data }).then(tools.catchResultHandle);
};

/**
 * 获取订单详情
 * @param orderId
 * @returns {*}
 */
export const getOrderDetail = (orderId) => {
  const url = api.concat('/api/order/getOrderDetailsByH5');
  const data = { orderId };
  return request.get({ url, data }).then(tools.catchResultHandle);
};

/**
 * 获取pdf 文件流
 * @param fileUrl
 * @returns {AxiosPromise}
 */
export const getFileBold = (fileUrl) => {
  const url = api.concat('/api/file/download');
  const data = { url: fileUrl };
  return request.getBoldData(url, data);
};

/**
 * 获取验证码
 */
export const getYcode = (opt) => {
  const url = api.concat('/h5/register/getYcode');
  const data = { ...opt };
  return request.postJson({ url, data });
};

/**
 * 员工或者企业邀请注册个人渠道
 */
export const getpersonal = (opt) => {
  const url = api.concat('/h5/register/personal_register');
  const data = { ...opt };
  return request.postJson({ url, data });
};

/**
 * 员工或者企业邀请注册公司渠道
 */
export const getcompany = (opt) => {
  const url = api.concat('/h5/register/company_register');
  const data = { ...opt };
  return request.postJson({ url, data });
};

/**
 * 企业查询H5自定义链接
 */
export const getCustom = ({ staffUserId, companyCode }) => {
  const url = api.concat('/h5/register/get_custom_h5_url');
  const data = { staffId: staffUserId, companyCode };
  return request.postJson({ url, data }).then(tools.catchResultHandle);
};

/**
 * 获取地址 by openId
 */
export const getAddressByOpenId = () => {
  const url = api.concat('/api/order/getConsigneeInfo');
  const openId = localStorage.getItem('openId') || null;

  if (!openId) {
    return Promise.reject(
      new Error('未保存openId'),
    );
  }

  const data = { openId };
  return request.get({ url, data }).then((res) => res.data);
};

// 趣销销活动Api

/**
 * 趣销销转发查看全部
 */
export const getMoreActivity = () => {
  // const url = api.concat(`/h5/register/get_custom_h5_url`);
  // const data = { staffId: staffUserId, companyCode: companyCode };
  const data = [
    {
      content: '转发',
      amount: '1',
      complete: true,
    },
    {
      content: '转发给你的,',
      amount: '2',
      complete: true,
    },
    {
      content: '转发后，通',
      amount: '3',
      complete: false,
    },
  ];
  return Promise.resolve(data);
};

// 查询产品是否有有效的营销活动

export const getEffectiveActivities = (productId) => {
  const url = api.concat('/marketing/getEffectiveActivities');
  const data = { productId };
  return request.post({ url, data }).then((res) => res.data);
};

// 获取趣销销公众号AppId

export const getMarketingWxConfiguration = () => {
  const url = api.concat('/marketing/getMarketingWxConfiguration');
  return request.post({ url }).then((res) => res);
};

// 获取趣销销公众号openId

export const getMarketingOpenId = (code) => {
  const url = api.concat('/api/order/getMarketingOpenId');
  const data = { code };
  return request.get({ url, data }).then((res) => res);
};

// 获取趣销销公众号活动规则

export const getAwardRulesInfoByMarketingId = (openId, productId, marketingId) => {
  const url = api.concat('/marketing/getAwardRulesInfoByMarketingId');
  const data = { openId, marketingId };
  return request.post({ url, data }).then((res) => res);
};

// 转发领钱

export const getAwardRulesInfo = (openId, productId) => {
  const url = api.concat('/marketing/getAwardRulesInfo');
  const data = { openId, productId };
  return request.post({ url, data }).then((res) => res);
};
// 传播奖励

export const spread = (spreadOpenId, productId, forwardOpenId, sourceUrl) => {
  const url = api.concat('/marketing/spread');
  const data = {
    spreadOpenId, productId, forwardOpenId, sourceUrl,
  };
  return request.post({ url, data }).then((res) => res.data);
};

// 转发奖励

export const forward = (openId, productId, sourceUrl) => {
  const url = api.concat('/marketing/forward');
  const data = { openId, productId, sourceUrl };
  return request.post({ url, data }).then((res) => res);
};

// 转发奖励

export const getMarketingIncentivesByOpenId = (openId) => {
  const url = api.concat('/marketing/getMarketingIncentivesByOpenId');
  const data = { openId, pageSize: 10000, pageNum: 1 };
  return request.post({ url, data }).then((res) => res);
};

// 提现

export const toCash = (openId, marketingId, amount) => {
  const url = api.concat('/marketing/to_cash');
  const data = { openId, marketingId, amount };
  return request.post({ url, data }).then((res) => res);
};

// 服务号-我的奖励

export const getMarketingAward = (openId) => {
  const url = api.concat('/marketing/getMarketingAward');
  const data = { openId };
  return request.post({ url, data }).then((res) => res);
};

// 渠道相关--获取问题

export const getChannelApplyForm = (pageSize, pageNum, category) => {
  const url = api.concat('/api/product/getChannelApplyForm');
  const data = { pageSize, pageNum, category };
  return request.post({ url, data }).then((res) => res);
};

// 渠道相关--问题提交

export const saveChannelApplyForm = (answers, category, settingId, score) => {
  const url = api.concat('/api/product/saveChannelApplyForm');
  const data = {
    answers, category, settingId, score,
  };
  return request.post({ url, data }).then((res) => res.data);
};

// 渠道相关--查看完成状态

export const getTaskCompletion = () => {
  const url = api.concat('/api/my/get_task_completion');
  return request.post({ url }).then((res) => res);
};

// 查询签署合约是否配置
export const getSignInfo = () => {
  const url = api.concat('/api/channel/sign/get_sign_info');
  return request.post({ url }).then((res) => res);
};

// 开户注册
export const openAccount = (data) => {
  const url = api.concat('/h5/register/open_account');
  return request.post({ url, data });
};

// 获取开户的配置
export const getOpenAccountConfig = (productId) => {
  const url = api.concat('/h5/register/get_register_info');
  const data = {
    productId,
  };
  return request.post({ url, data });
};
// 获取剩余次数
export const getMaxTimes = (settingId) => {
  const url = api.concat('/api/product/getMaxTimes');
  const data = { settingId };
  return request.post({ url, data }).then((res) => res);
};

// 员工审核申请表和测试问答

export const auditApplyForm = (userId, category, auditStatus) => {
  const url = api.concat('/api/product/auditApplyForm');
  const data = { userId, category, auditStatus };
  return request.post({ url, data });
};

// 渠道相关--获取问题by userid

export const getChannelApplyFormByUserId = (pageSize, pageNum, category, userId) => {
  const url = api.concat('/api/product/getChannelApplyFormByUserId');
  const data = {
    pageSize, pageNum, category, userId,
  };
  return request.post({ url, data }).then((res) => res);
};

// 通过userId查询渠道任务完成情况

export const getTaskCompletionUserId = (userId) => {
  const url = api.concat('/api/my/get_task_completion_userId');
  const data = { userId };
  return request.post({ url, data }).then((res) => res);
};

// 通过ProductId查询学习资料
export const getStudyFiles = (isLearn) => {
  const url = api.concat('/api/channel/lmaterials/getLmaterialsList');
  const data = { isLearn, pageSize: 10000, pageNum: 1 };
  return request.post({ url, data }).then((res) => res);
};

// 学习点击
export const learnStatistics = (lmaterialsId) => {
  const url = api.concat('/api/channel/lmaterials/learnStatistics');
  const data = { lmaterialsId };
  return request.post({ url, data }).then((res) => res);
};

/**
 * 直播相关
 */
// 获取im签名
export const getImUserSig = (identifier, name, headUrl, type) => {
  const url = live.concat('/api/live/getUserSig');
  const data = {
    identifier, name, headUrl, type,
  };
  return request.postJson({ url, data }).then((res) => res);
};

// 获取openid
export const getImOpenId = (code, type) => {
  const url = live.concat('/api/live/getOpenId');
  const data = { code, type };
  return request.postJson({ url, data }).then((res) => res);
};

// 获取appId
export const getImAppId = () => request.post({ url: live.concat('/api/live/getAppId') });

// 进入直播间
export const verifyGetLive = (id, openId, mobile, shareUserId) => {
  const url = live.concat('/api/live/verifyGetLive');
  const data = {
    id, openId, mobile, shareUserId,
  };
  return request.postJson({ url, data }).then((res) => res);
};

// 通过公司名获取候选
export const getCompanyNameOptions = (companyName) => {
  const url = api.concat('/h5/register/get_companys_by_name');

  return request.post({ url, data: { companyName } }).then((res) => res.data);
};
// 进入录播间
export const verifyVodLive = (
  streamName, userName, userId, openId, verifyType, mobile, liveId, shareUserId,
) => {
  const url = live.concat('/api/live/verifyVodLive');
  const data = {
    streamName, userName, openId, userId, verifyType, mobile, liveId, shareUserId,
  };
  return request.postJson({ url, data }).then((res) => res);
};

// 获取直播间详情
export const getOpenType = (streamName, openId, liveId) => {
  const url = live.concat('/api/live/getOpenType');
  const data = { streamName, openId, liveId };
  return request.postJson({ url, data }).then((res) => res);
};

/**
 * 获取微信分享配置信息
 * @param qrCodeurl
 * @returns {*}
 */
export const getWxShareInfo = (qrCodeurl) => {
  const url = api.concat('/marketing/getWxShareInfo');
  const data = { url: qrCodeurl };
  return request.get({ url, data }).then((res) => res.data);
};
/**
 * 直播发送验证码
 * @param qrCodeurl
 * @returns {*}
 */
export const liveSendMsg = (data) => {
  const url = live.concat('/api/live/sendSms');
  // const data = { type, mobile }
  return request.post({ url, data });
};
/**
 * 校验验证码啊
 * @param qrCodeurl
 * @returns {*}
 */
export const checkCode = (mobileType, mobile, code) => {
  const url = live.concat('/api/live/checkCode');
  const data = { mobileType, mobile, code };
  return request.post({ url, data }).then((res) => res);
};

/**
 * 删除群成员
 * @param qrCodeurl
 * @returns {*}
 */
export const delGroupMember = (groupId, userId) => {
  const url = live.concat('/api/live/delGroupMember');
  const data = { groupId, userId };
  return request.post({ url, data }).then((res) => res);
};

/**
 * 关联商品
 * @param products
 * @returns {*}
 */
export const getLiveProduct = (products) => {
  const url = api.concat('/h5/product/get_live_product');
  const data = { products };
  return request.post({ url, data }).then((res) => res);
};

/**
 * 获取直播间详情
 * @param data
 * @returns {*}
 */
export const getLiveDetail = (data) => request.post({ url: live.concat('/api/live/getLive'), data }).then((res) => res);

/**
 * 报名
 */
export const getSignUp = (data) => request.post({ url: live.concat('/api/live/signUp'), data });

/**
 * 获取报名所需信息
 * @param data
 */
export const getSignUpPage = (data) => request.post({ url: live.concat('/api/live/getSignUpPage'), data }).then((res) => res);

/**
 * 是否校验个人手机号
 */
export const getCheckPhone = (data) => request.post({ url: live.concat('/api/live/getOpenType'), data }).then((res) => res);

/**
 * 直播间点赞
 * @returns {*}
 * @param streamName
 * @param openId
 */
export const giveFabulous = (id, openId) => request.post({
  url: live.concat('/api/live/giveFabulous'),
  data: { id, openId },
}).then((res) => res);

/**
 * 商品列表
 * @returns {*}
 * @param streamName
 * @param isPage
 */
export const getCompanyProducts = (extendId, isPage = false) => request.post({
  url: live.concat('/api/live/getCompanyProducts'),
  data: { extendId, isPage },
}).then((res) => res);

/**
 * -直播间列表
 * @returns {*}
 * @param data
 * @param isPage
 */
export const getShoppingRoomLive = (data, isPage = true) => request.post({
  url: live.concat('/api/live/get_shopping_room_live'),
  data: { ...data, isPage },
}).then((res) => res);

/**
 * 商品列表
 * @returns {*}
 * @param data
 * @param isPage
 */
export const getShoppingRoom = (data, isPage = true) => request.post({
  url: live.concat('/api/live/getShoppingRoom'),
  data: { ...data, isPage },
}).then((res) => res);

/**
 * 排行榜
 * @returns {*}
 * @param data
 */
export const getUserRank = (data) => request.post({
  url: live.concat('/api/live/getUserRank'),
  data,
}).then((res) => res);

/**
 * 分享二维码
 * @returns {*}
 * @param data
 */
export const shareQrCode = (data) => request.post({
  url: live.concat('/api/live/shareQrCode'),
  data,
}).then((res) => res);

// 接受邀请成为直播间讲师
export const acceptInvitePool = (data) => request.post({
  url: live.concat('/api/live/accept_invite_pool'),
  data,
}).then((res) => res);

/**
 * 分享链接
 * @returns {*}
 * @param data
 */
export const shareUrl = (data) => request.post({
  url: live.concat('/api/live/shareUrl'),
  data,
}).then((res) => res);
